import { useEffect, useState } from "react"
import { Product } from "./EnterpriseReport";

interface ProductVariation {
    quantity: number,
    id: number,
    name: string,
}

export default function ProductRow(props: {product: Product}) {
    const [isOpen, setIsOpen] = useState(false);
    const [product, setProduct] = useState<Product>({} as Product)
    const [productVariations, setProductVariations] = useState<ProductVariation[]>([])

    useEffect(() => {
        setProduct(props.product)
        setProductVariations(props.product.productsVariations);
    })

    return(
        <>
            <tr onClick={() => isOpen ? setIsOpen(false) : setIsOpen(true)}>
                <td>{product.productsVariations !== [] && isOpen ? "▼" : "►"}</td>
                <td>{product.quantity}</td>
                <td>{product.productId}</td>
                <td>{product.name}</td>
            </tr>
            {isOpen && productVariations && productVariations.map(variation => {
                return(
                    <tr className="variation" style={{color: "black"}}>
                        <td></td>
                        <td>{variation.quantity}</td>
                        <td>{variation.id}</td>
                        <td>{variation.name}</td>
                    </tr>
                )
            })}
        </>
    )
}